import React from 'react';
import { Select, Row, Col, Spin } from 'antd';
import { titleCase } from '@/ts/utils';
import { IChannels } from '@/ts/common-types';
import '@/scss/_channel-icons.scss';

const { Option } = Select;

interface ChannelSelectProps {
    channels: IChannels[];
    value?: number | number[];
    onChange?: (value: any) => void;
    mode?: 'multiple' | undefined;
    disabled?: boolean;
    loading?: boolean;
    placeholder?: string;
    className?: string;
}

const ChannelSelect: React.FC<ChannelSelectProps> = ({
    channels = [],
    value,
    onChange,
    mode,
    disabled = false,
    loading = false,
    placeholder = "Select Channel",
    className = "w-100"
}) => {
    const filterOption = (input: string, option: any) => {
        return option?.children?.props?.children[1]?.props?.children
            .toString()
            .toLowerCase()
            .includes(input.toLowerCase());
    };

    return (
        <Select
            mode={mode}
            value={value}
            onChange={onChange}
            disabled={disabled}
            placeholder={placeholder}
            className={className}
            filterOption={filterOption}
            showSearch
        >
            {loading ? (
                <Option value='null'>
                    <div className="d-flex align-items-center justify-content-center h-100">
                        <Spin size="small" />
                    </div>
                </Option>
            ) : (
                channels.map((channel) => {
                    return (
                        <Option
                            key={channel.channel_id}
                            value={channel.channel_id}
                        >
                            <Row className="d-flex align-items-center">
                                <Col className="me-2">
                                    <img 
                                        className="channel-icon" 
                                        src={channel.logo_url || ''} 
                                        alt={channel.name} 
                                    />
                                </Col>
                                <Col>{titleCase(channel.name)}</Col>
                            </Row>
                        </Option>
                    );
                })
            )}
        </Select>
    );
};

export default ChannelSelect;